'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002413 from "./presto.-Presto$$anon$13.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002415 from "./presto.-Presto$$anon$15.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00243 from "./presto.-Presto$$anon$3.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00245 from "./presto.-Presto$$anon$5.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$2() {
  this.bao = null;
  this.bag = null;
  this.bah = false;
  this.bap = null;
  this.baq = false;
  this.bat = null;
  this.bam = null;
  this.ban = false;
  this.bai = null;
  this.baj = false;
  this.bak = null;
  this.bal = false;
  this.bar = false;
  this.bas = false;
  this.bao = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bat = "SingleAppUser";
}
export { $c_Lpresto_Presto$$anon$2 as $c_Lpresto_Presto$$anon$2 };
$p = $c_Lpresto_Presto$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$2;
/** @constructor */
function $h_Lpresto_Presto$$anon$2() {
}
export { $h_Lpresto_Presto$$anon$2 as $h_Lpresto_Presto$$anon$2 };
$h_Lpresto_Presto$$anon$2.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bao;
});
$p.M = (function() {
  if ((!this.bah)) {
    this.bag = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bah = true;
  }
  return this.bag;
});
$p.O = (function() {
  if ((!this.baq)) {
    this.bap = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.baq = true;
  }
  return this.bap;
});
$p.E = (function() {
  return this.bat;
});
$p.t = (function() {
  if ((!this.ban)) {
    this.bam = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.ban = true;
  }
  return this.bam;
});
$p.N = (function() {
  if ((!this.baj)) {
    this.bai = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00243.$c_Lpresto_Presto$$anon$3(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00245.$c_Lpresto_Presto$$anon$5(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dPresto$0024$0024anon$002413.$c_Lpresto_Presto$$anon$13())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.baj = true;
  }
  return this.bai;
});
$p.Q = (function() {
  if ((!this.bal)) {
    this.bak = new $j_presto$002e$002dPresto$0024$0024anon$002415.$c_Lpresto_Presto$$anon$15();
    this.bal = true;
  }
  return this.bak;
});
$p.v = (function() {
  if ((!this.bas)) {
    this.bar = false;
    this.bas = true;
  }
  return this.bar;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee95) => ((p) => \u03b4scrutinee95.ad0(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_Presto$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$2, "presto.Presto$$anon$2", ({
  Nm: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$2 as $d_Lpresto_Presto$$anon$2 };
//# sourceMappingURL=presto.-Presto$$anon$2.js.map
